// extracted by mini-css-extract-plugin
export var articleWrap = "randomPosts-module--articleWrap--Rgk1Q";
export var randomPostsWrap = "randomPosts-module--randomPostsWrap--8gYgG";